<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout mt-4 wrap mr-2>
      <v-flex xs12>
        <v-subheader>Subcategories (optional)*</v-subheader>
      </v-flex>
    </v-layout>
    <div v-for="(subcategory, index) in subcategories" :key="index">
      <v-layout ml-4 wrap mr-4>
        <v-flex xs4>
          <v-subheader>Subcategory name</v-subheader>
        </v-flex>
        <v-flex xs4>
          <v-text-field v-model="subcategories[index].name" outlined dense />
        </v-flex>
        <v-flex xs1 ml-2>
          <v-icon @click="removeSubcategory(index)" color="error"
            >remove_circle</v-icon
          >
        </v-flex>
      </v-layout>
    </div>
    <v-layout>
      <v-flex>
        <v-btn color="primary" @click="addSubcategory">Add Subcategory</v-btn>
      </v-flex>
    </v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn @click="add" :disabled="!valid" color="primary">Add</v-btn>
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import request from "@/modules/request";
import ActionModal from "./ActionModal";

export default {
  name: "AddCategoryModal",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    valid() {
      return this.subcategories.some((sub) => {
        return sub.name.length;
      });
    },
  },
  data() {
    return {
      subcategories: [
        {
          name: "",
        },
      ],
    };
  },
  components: {
    ActionModal,
  },
  methods: {
    close() {
      this.$emit("update:addSubcategoryModal", false);
    },
    addSubcategory() {
      this.subcategories.push({
        name: "",
      });
    },
    removeSubcategory(index) {
      this.subcategories.splice(index, 1);
    },
    add() {
      const { subcategories } = this;
      const validSubcategories = subcategories.filter((sub) => sub.name.length);
      this.$emit("addSubcategories", validSubcategories);
    },
  },
};
</script>
